<h2 mat-dialog-title>{{ 'Új ország' | translate }}</h2>
<mat-dialog-content>
  <form class="input-row" [formGroup]="countryForm">
    <app-country-picker 
      [formGroup]="countryForm"
      formKey="country"></app-country-picker>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close><span translate>Mégse</span></button>
  <button mat-button color="primary" (click)="closeWithSave()" [disabled]="!countryForm.valid"><span translate>Hozzáadás</span></button>
</mat-dialog-actions>
